import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'setup.territory.header.title' }),
    description: translate({ id: 'setup.territory.header.description' }),
    timezone: translate({ id: 'setup.territory.timezone' }),
    borderRestrictionLabel: translate({ id: 'setup.territory.borderRestriction' }),
    borderRestrictionNote: translate({ id: 'setup.territory.borderRestriction.note' }),
    noBorderRestriction: translate({ id: 'setup.territory.borderRestriction.empty' }),
  }))

  return api
}
